import * as React from 'react';
import { FormInputRadio } from './form-input-radio';
import { centerCenter, vertical, verticallySpaced } from 'csstips';
import { classes, style } from 'typestyle';
import { important, px } from 'csx';
import { colorBackground, rebrand } from '../theme/color';
import { transitionQuickEase } from '../theme/transition';
import { mediaMobileOnly } from '../theme/media';

export interface PreferenceItemProps {
  label: string;
  group: string;
  selected: boolean;
  onSelect(): void;
  disabled?: boolean;
  reducedOptions?: boolean;
}

export class PreferenceItem extends React.Component<PreferenceItemProps, any> {
  render() {
    const { label, group, selected, disabled, onSelect, reducedOptions } = this.props;

    return (
      <div
        className={classes(PreferenceItem.styles.container(reducedOptions), disabled && PreferenceItem.styles.disabled)}
      >
        <FormInputRadio
          name={group}
          value={selected}
          onChange={() => !selected && onSelect()}
          disabled={disabled}
          placeholder={label}
        />
        <div className={PreferenceItem.styles.label} onClick={() => !selected && onSelect()}>
          {label}
        </div>
      </div>
    );
  }

  static styles = {
    container: (reduceOptions: boolean) =>
      style(
        mediaMobileOnly({
          width: reduceOptions ? '50%' : '25%',
          borderRight: `2px solid ${rebrand.contrast[10].toString()}`,
          borderTop: `2px solid ${rebrand.contrast[10].toString()}`,
          borderLeft: 'none',
        }),
        {
          ...vertical,
          ...verticallySpaced(5),
          ...centerCenter,
          cursor: 'default',
          padding: px(12),
          width: px(112),
          height: '100%',
          borderLeft: `2px solid ${rebrand.contrast[10].toString()}`,
          transition: `color ${transitionQuickEase}`,
          $nest: {
            '&:last-child': mediaMobileOnly({
              borderRight: 'none',
            }),
          },
        }
      ),
    disabled: style({
      color: important(colorBackground.toString()),
    }),
    label: style(
      mediaMobileOnly({
        fontSize: px(12),
      })
    ),
  };
}
